export default __webpack_public_path__ + "locales/tr/PreparationPortal.json?hash=9e2c67a55458dd786c27ccc3afffb02c";